(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection Sort Handler (used by both Radio and OOH – expose on window for inline onchange)
  function handleOOHSortChange(select) {
    const kind = select && select.classList && select.classList.contains('radio-collection-sort') ? 'RADIO' : 'OOH';
    console.log('[Sort] handleOOHSortChange called', { collection: kind, select: select, value: select?.value, options: select ? Array.from(select.options).map(o => o.value) : [] });
    if (!select) {
      console.error('[Sort] No select element passed');
      return;
    }
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const sortBefore = params.get('sort_by');
    console.log('[Sort] Current URL:', url.toString());
    console.log('[Sort] Current sort_by (from URL):', sortBefore || '(none)');
    console.log('[Sort] Selected option value:', select.value);
    console.log('[Sort] Removing page param so sort change lands on page 1');

    params.delete('sort_by');
    params.delete('page'); // Reset to page 1 when sort changes
    if (select.value) {
      params.set('sort_by', select.value);
    }
    url.search = params.toString();
    console.log('[Sort] New URL:', url.toString());
    console.log('[Sort] Params (after):', Object.fromEntries(params));
    console.log('[Sort] Redirecting to apply', select.value, 'for', kind, 'collection');
    window.location.href = url.toString();
  }
  window.handleOOHSortChange = handleOOHSortChange;
  console.log('[Sort] handleOOHSortChange attached to window:', typeof window.handleOOHSortChange);


  } catch(e) { console.error(e); }
})();
})();
